<template>
  <div class="page">
    <list
      title="Outros Documentos"
      tag="others"
      subtitle="Nesta tela você cria e verifica os templates de consultas de outros documentos."
      :create-route="{ name: 'Template-Other-Create' }"
    />
  </div>
</template>

<script>
import List from '@/template/components/List.vue';

export default {
  name: 'Index',

  components: {
    List,
  },
};
</script>

<style scoped>

</style>
